import { Box, Button, Modal, Switch, TextField } from '@mui/material'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import { getDataById, saveOrUpdateDataById } from '../apis/generalApis'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
  maxHeight: '90vh',
  overflow: 'auto',
}

const weekDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]
const availableDays = [
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate()) - 1).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
  },
  {
    day: weekDays[new Date(new Date().setDate(new Date().getDate())).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 1)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 2)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 3)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 4)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
  },
  {
    day:
      weekDays[new Date(new Date().setDate(new Date().getDate() + 5)).getDay()],
    start_time: '',
    end_time: '',
    break_start: '',
    break_end: '',
    is_working: false,
    is_break: false,
  },
]

const ManageOnGoingAvailabilityModal = ({
  toggleOngoingAvailabilityModal,
  modalOpen,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [checked, setChecked] = React.useState(
    new Array(weekDays.length).fill(false),
  )
  const [availability, setAvailability] = useState([...availableDays])

  const [addBreak, setAddBreak] = useState(
    new Array(weekDays.length).fill(false),
  )

  useEffect(() => {
    getStylistAvailability()
  }, [])

  const getStylistAvailability = async () => {
    const result = await getDataById('show-all-availabilities', {
      user_id: user?.id,
    })
    if (result?.success === true && result?.data) {
      if (result?.data?.length > 0) {
        setAvailability(result?.data)
      } else {
        setAvailability([...availableDays])
      }
    }
  }

  const handleChange = (event, position) => {
    setAvailability((prev) =>
      prev.map((item, index) => {
        if (position === index) {
          return { ...item, is_working: !item?.is_working }
        } else return { ...item }
      }),
    )
  }


  const handleAddBreak = (event, position) => {
    setAvailability((prev) =>
      prev.map((item, index) => {
        if (position === index) {
          return { ...item, is_break: !item?.is_break }
        } else return { ...item }
      }),
    )
  }

  const handleTimeChange = (e, index) => {
    setAvailability((prev) =>
      prev.map((item, ind) => {
        if (ind === index) {
          return { ...item, [e.target.name]: e.target.value }
        } else return { ...item }
      }),
    )
  }

  const handleOngoingAvailability = async (e) => {
    e.preventDefault()
    let body = { user_id: user?.id, day: availability }
    let result = await saveOrUpdateDataById('add-availability', body)
    if (result?.success === true) {
      const arr = new Array(7).fill(false)
      setChecked(arr)
      Swal.fire({
        icon: 'success',
        title: 'Ongoing Availability updated successfully!',
        timer: 3000,
        confirmButtonColor: '#2597F6',
      })
    }
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => toggleOngoingAvailabilityModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          {/* <Container> */}
          <div className="ongoing-availability-modal-wrapper">
            <h3 className="fs-24 mb-4 fw-bold">Manage Ongoing Availability</h3>
            <form onSubmit={handleOngoingAvailability}>
              {availability.map((day, index) => {
                return (
                  <div key={index}>
                    <div
                      className="day-section mt-3 px-2 d-flex justify-content-between align-items-center"
                      key={index}
                    >
                      <p className="m-0 text-capitalize">{day?.day}</p>
                      <div className="py-1">
                        <Switch
                          checked={day?.is_working}
                          size={'small'}
                          key="index"
                          className="switch"
                          onChange={(e) => handleChange(e, index)}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </div>
                    </div>
                    {availability[index]?.is_working && (
                      <div>
                        <div>
                          <div className="set-time px-2 py-2">
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="m-0 font-weight-bold">Hours</p>
                              <div>
                                <TextField
                                  id="time"
                                  type="time"
                                  value={day?.start_time}
                                  name="start_time"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  required={day?.is_working}
                                  onChange={(e) => handleTimeChange(e, index)}
                                />
                              </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-2">
                              <p className="m-0 font-weight-bold">To</p>
                              <div>
                                <TextField
                                  onChange={(e) => handleTimeChange(e, index)}
                                  id="time"
                                  value={day?.end_time}
                                  type="time"
                                  name="end_time"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  required={day?.is_working}
                                />
                              </div>
                            </div>
                          </div>
                          {availability[index]?.is_break && (
                            <div className="set-time px-2 py-2">
                              <div className="d-flex justify-content-between align-items-center">
                                <p className="m-0 font-weight-bold">BREAK</p>
                                <div>
                                  <TextField
                                    onChange={(e) => handleTimeChange(e, index)}
                                    id="time"
                                    type="time"
                                    required={day?.is_break}
                                    value={day?.break_start}
                                    name="break_start"
                                    title={'Please add time or remove break'}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <p className="m-0 font-weight-bold">TO</p>
                                <div>
                                  <TextField
                                    onChange={(e) => handleTimeChange(e, index)}
                                    id="time"
                                    value={day?.break_end}
                                    required={day?.is_break}
                                    title={'Please add time or remove break'}
                                    type="time"
                                    name="break_end"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="m-0 break">
                            <h3
                              className="fs-12 mt-2 pointer"
                              style={
                                availability[index]?.is_break
                                  ? { color: 'red' }
                                  : {}
                              }
                              onClick={(e) => handleAddBreak(e, index)}
                            >
                              {availability[index]?.is_break
                                ? 'REMOVE BREAK'
                                : 'ADD BREAK'}
                            </h3>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )
              })}
              <Button
                fullWidth
                id="btn-primary-no-shadow"
                className="mt-3"
                type="submit"
              >
                Save
              </Button>
            </form>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default ManageOnGoingAvailabilityModal
